import type { TOC } from '@ember/component/template-only'
import { ThStandard } from 'teacher-ui-client/components/th/standard'
import { t } from 'ember-intl'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import type { BooksReadOverviewReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'

interface Args {
  isLoading?: boolean
  overviewData: BooksReadOverviewReportData['overview']
}

interface Signature {
  Args: Args
  Element: HTMLTableElement
}
export const StudentBooksReadOverview: TOC<Signature> = <template>
  <table class="border-oceany-blue-150 border-b text-center" ...attributes>
    <thead class="bg-oceany-blue-50">
      <tr class="divide-x divide-white">
        <th></th>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.daysRead"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.booksRead"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.chaptersRead"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.wordsRead"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.questions"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.averageScore"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
      <tr>
        <th class="p-3 text-left font-normal">
          {{t "classifications.fiction"}}
        </th>
        <td class="p-3">{{formatValue @overviewData.classifications.fiction.days_read}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.fiction.books_read}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.fiction.chapters_read}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.fiction.words_read}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.fiction.questions}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.fiction.average_score append="%"}}</td>
      </tr>
      <tr>
        <th class="p-3 text-left font-normal">
          {{t "classifications.nonfiction"}}
        </th>
        <td class="p-3">{{formatValue @overviewData.classifications.nonfiction.days_read}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.nonfiction.books_read}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.nonfiction.chapters_read}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.nonfiction.words_read}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.nonfiction.questions}}</td>
        <td class="p-3">{{formatValue @overviewData.classifications.nonfiction.average_score append="%"}}</td>
      </tr>
      <tr>
        <th class="p-3 text-left font-semibold">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.total"}}
        </th>
        <td></td>
        <td class="p-3 font-semibold">{{formatValue @overviewData.total.books_read}}</td>
        <td class="p-3 font-semibold">{{formatValue @overviewData.total.chapters_read}}</td>
        <td class="p-3 font-semibold">{{formatValue @overviewData.total.words_read}}</td>
        <td class="p-3 font-semibold">{{formatValue @overviewData.total.questions}}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

export default StudentBooksReadOverview
